import styled from 'styled-components'
import { cssMediaQueryBreakpoints } from '../../../config/breakpoints'

export const PopupSpeedAdjustmentButtonWrapper = styled.div`
    display: none;

    ${cssMediaQueryBreakpoints.medium} {
        display: block;
    }
`
